import { Inject, Component, Optional } from "@angular/core";

import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { BaseDetailItemComponent } from "../shared/baseDetailItemComponent";
import { VisualizationPanel, GroupConfUIItem } from "../../../shared/models";
import { ProductDataStore } from "../../../shared/providers/productData";
import { type } from "jquery";

@Component({
  selector: 'visualization-detail',
  templateUrl: './visualizationDetailComponent.html',
})
export class VisualizationDetailComponent extends BaseDetailItemComponent {

  public showDetailBoxHeader: boolean = true;
  public detailBoxTitle: string;
  public showPanelTitle: boolean = false;
  public visualizationPanels: VisualizationPanel[] = [];

  constructor(@Optional() @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(ProductDataStore) public productStore: ProductDataStore
  ) {
    super(confPageSessionService);
  }

  onDataReady(): void {

    this.visualizationPanels = this.getPanels();
    if (this.visualizationPanels && this.visualizationPanels.length > 0) {

      this.visible = true;
      this.detailBoxTitle = this.strings.Visualizations;
      if (this.visualizationPanels.length > 1)
        this.showPanelTitle = true;
      else {

        this.showPanelTitle = false;

        let firstPanel = this.visualizationPanels[0];
        if (firstPanel.title && firstPanel.title.trim().length > 0)
          this.detailBoxTitle = firstPanel.title;
        // For individually displayed panel if there is no title then hide the whole header row
        else if (typeof this.confUIItem != typeof GroupConfUIItem)
          this.showDetailBoxHeader = false;
      }
    }
  }

  getPanels() {

    let panels: VisualizationPanel[] = [];

    if (this.confUIItem && this.confUIItem.id) {

      let panel = this.productStore.getEntity<VisualizationPanel>(this.confUIItem.id);
      if (panel)
        panels.push(panel);
    }
    else if (this.confUIItem.items && this.confUIItem.items.size > 0) {

      if (this.confUIItem.items && this.confUIItem.items.size > 0) {
        this.confUIItem.items.forEach(x => {

          let panel = this.productStore.getEntity<VisualizationPanel>(x.id);
          if (panel)
            panels.push(panel);
        });
      }

    }

    return panels;
  }
}